import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  setPage,
  setTotal,
  setLimit,
  setColumnVisibility,
  setFreebetUsageTableFilters,
  setClearFreebetUsageTableFilters,
} from '@Modal/reducers/freebetsUsage/freebetUsageTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useFreebetsUsageTable = () => {
  const dispatch = useDispatch();

  const {
    limit,
    page,
    total,
    selectedFilters,
    columnVisibility,
    columnVisibilityOptions,
    freebetUsageTableFilters,
  } = useSelector((state: StoreInterface) => state?.freebetsUsageTable);

  const freebetsUsageListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...freebetsUsageListFilters, ...column];
    if (freebetsUsageListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = freebetsUsageListFilters.filter((col) => col !== column[0]);
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setFreebetUsageTableFilters(filter));
  };

  const handleClearFreebetsUsageTableFilters = () => {
    dispatch(setClearFreebetUsageTableFilters());
  };

  return {
    // State
    page,
    total,
    limit,
    selectedFilters,
    columnVisibility,
    visiblityCustomizable,
    columnVisibilityOptions,
    freebetUsageTableFilters,
    freebetsUsageListFilters,
    // Actions
    setPage,
    setTotal,
    setLimit,
    setFreebetUsageTableFilters,
    setClearFreebetUsageTableFilters,
    // Handlers
    handleFilterSelect,
    handleApplyColumnVisibility,
    handleClearFreebetsUsageTableFilters,
  };
};
